import SvgIcon from '@mui/material_v7/SvgIcon';

import { IconProps } from './types';

const ExpandLessIcon = (props: IconProps) => (
  <SvgIcon {...props}>
    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.9998 6.0252C9.86647 6.0252 9.74147 6.04603 9.6248 6.0877C9.50814 6.12936 9.3998 6.2002 9.2998 6.3002L4.6998 10.9002C4.51647 11.0835 4.4248 11.3169 4.4248 11.6002C4.4248 11.8835 4.51647 12.1169 4.6998 12.3002C4.88314 12.4835 5.11647 12.5752 5.3998 12.5752C5.68314 12.5752 5.91647 12.4835 6.0998 12.3002L9.9998 8.4002L13.8998 12.3002C14.0831 12.4835 14.3165 12.5752 14.5998 12.5752C14.8831 12.5752 15.1165 12.4835 15.2998 12.3002C15.4831 12.1169 15.5748 11.8835 15.5748 11.6002C15.5748 11.3169 15.4831 11.0835 15.2998 10.9002L10.6998 6.3002C10.5998 6.2002 10.4915 6.12936 10.3748 6.0877C10.2581 6.04603 10.1331 6.0252 9.9998 6.0252Z"
        fill="currentColor"
      />
    </svg>
  </SvgIcon>
);

export default ExpandLessIcon;
